import { DOCUMENT } from '@angular/common';
import {
  ApplicationRef,
  Injectable,
  createComponent,
  inject,
} from '@angular/core';
import { VerifyAddressModalComponent } from './verify-address-modal.component';
import { Address } from 'api';
import { take } from 'rxjs';

@Injectable()
export class VerifyAddressModalService {
  private appRef = inject(ApplicationRef);
  private _document = inject<Document>(DOCUMENT);

  open(data: Address) {
    let hostElement = this._document.getElementById('ss-verify-address');
    if (!hostElement) {
      hostElement = this._document.createElement('div');
      hostElement.setAttribute('id', 'ss-verify-address');
      this._document.body.appendChild(hostElement);
    }

    const verifyAddressRef = createComponent(VerifyAddressModalComponent, {
      environmentInjector: this.appRef.injector,
      hostElement,
    });

    verifyAddressRef.instance.address$.next(data);

    verifyAddressRef.instance.selectedAddress$.pipe(take(1)).subscribe(() => {
      verifyAddressRef.destroy();
    });
    this.appRef.attachView(verifyAddressRef.hostView);
    return verifyAddressRef.instance.selectedAddress$;
  }
}
